import { api } from "@/api";
import { UpdateLeagueNewParams, LeagueDto } from "@/types/ApiResponses/League";

export const updateLeagueNew = async (
  params: UpdateLeagueNewParams
): Promise<LeagueDto> => {
  const { id, ...body } = params;
  const res = await api.client.patch(`/leagues-new/${id}`, body);
  return res.data;
};
